import React from 'react';
import { Calendar } from 'lucide-react';

export default function DateRangeFilter({ value, onChange, options }) {
  return (
    <div className="flex items-center gap-2 flex-shrink-0">
      <Calendar size={16} className="text-locate2-muted" />
      <select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="border border-locate2-border-light rounded-lg px-3 py-2.5 text-sm text-locate2-medium-gray bg-white focus:outline-none focus:ring-1 focus:ring-locate2-primary focus:border-locate2-primary transition-colors"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
